import { render } from "./vBox_Activity.vue?vue&type=template&id=6aa3588a"
import script from "./vBox_Activity.vue?vue&type=script&lang=js"
export * from "./vBox_Activity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__